/* eslint-disable no-undef */
import JSZip from 'jszip';
import FileSaver from 'file-saver';

import * as InviteLibrela from '../modules/experiencelibrela';
import * as InviteSolensia from '../modules/experiencesolensia';

/**
 * @ngdoc function
 * @name myConsultApp.controller:iepDetailViewController
 * @description
 * # iepDetailViewController
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'iepDetailViewController',
    (
      $scope,
      $document,
      $location,
      $timeout,
      $rootScope,
      MediaService,
      $routeParams,
      $filter,
      PetsService,
      crumble,
      utilitiesV2,
    ) => {
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      } else {
        $scope.crumble = crumble;
        crumble.update();
      }

      /*
       *  Scope Variables
       *
       */
      $scope.product = $location.$$url.startsWith('/experience-librela') ? 'librela' : 'solensia';
      $scope.species = $scope.product === 'solensia' ? 'cat' : 'dog';
      $scope.trackingBehaviorLabels = {
        default: 'Tracking Behavior',
        jumping: 'Jumping up or down',
        climbing: 'Climbing up or down stairs',
        walking: 'Walking',
        running: 'Running/Chasing',
      };
      $scope.selectedTrackingBehavior = 'default';
      $scope.showTrackingBehaviorOptions = false;
      $scope.inviteEmailSubject =
        $scope.product === 'librela'
          ? InviteLibrela.generateInviteEmailSubject()
          : InviteSolensia.generateInviteEmailSubject();
      $scope.inviteEmailBody =
        $scope.product === 'librela'
          ? InviteLibrela.generateInviteEmailBody($scope.currentOrganization)
          : InviteSolensia.generateInviteEmailBody($scope.currentOrganization);
      $scope.inviteEmailBodyCopy =
        $scope.product === 'librela'
          ? InviteLibrela.generateInviteEmailBody($scope.currentOrganization, false)
          : InviteSolensia.generateInviteEmailBody($scope.currentOrganization, false);
      $scope.reminderEmailSubject =
        $scope.product === 'librela'
          ? InviteLibrela.generateReminderEmailSubject()
          : InviteSolensia.generateReminderEmailSubject();
      $scope.reminderEmailBody =
        $scope.product === 'librela'
          ? InviteLibrela.generateReminderEmailBody($scope.currentOrganization)
          : InviteSolensia.generateReminderEmailBody($scope.currentOrganization);
      $scope.reminderEmailBodyCopy =
        $scope.product === 'librela'
          ? InviteLibrela.generateReminderEmailBody($scope.currentOrganization, false)
          : InviteSolensia.generateReminderEmailBody($scope.currentOrganization, false);
      $scope.encodedInviteEmailBody = encodeURIComponent($scope.inviteEmailBody);
      $scope.linkCopied = false;
      $scope.showModal = false;
      $scope.petId = $routeParams.petId;
      $scope.weight = null;
      $scope.parentVideo = null;
      $scope.currentLink = $location.absUrl();
      $scope.order = 'id';
      $scope.mediaCategories = $scope.product === 'librela' ? '4' : '2';
      $scope.pageSize = '200';
      $scope.loadedMedia = [];
      $rootScope.errorModalOptions = {
        heading: 'Error',
        message:
          'No videos available for download or there was an error retrieving the videos, please try again later.',
        buttons: [
          {
            label: 'OK',
            href: '#',
            clickFn: () => {
              $rootScope.showErrorModal = false;
            },
          },
        ],
      };

      $scope.isInitialTreatmentDateValid = false;

      $scope.initialTreatmentDate = {
        current: null,
        previous: null,
      };

      $scope.vetObservations = null;
      $scope.videoObservations = null;
      $scope.downloadingVideo = false;
      $scope.downloadingAllVideos = false;
      $scope.savingObservations = false;
      $scope.savingVideoNotes = false;

      $scope.playVideo = (video) => {
        const settings = {
          files: {
            extra_data: {
              dr_viewed: true,
            },
          },
        };
        $scope.loadedMedia = [].concat(video);
        $scope.showModal = true;
        $scope.videoObservations = video.extra_data?.video_observations
          ? video?.extra_data.video_observations
          : $scope.videoObservations;
        if (!video.extra_data.dr_viewed) {
          $scope.updateServerMedia(video.id, settings);
        }
      };

      $scope.toggleTrackingBehaviorOptions = () => {
        $scope.showTrackingBehaviorOptions = !$scope.showTrackingBehaviorOptions;
      };

      $scope.trackingBehaviorChange = (val) => {
        const settings = {
          files: {
            extra_data: {
              tracking_behavior: val,
            },
          },
        };
        $scope.selectedTrackingBehavior = val;
        $scope.toggleTrackingBehaviorOptions();
        $scope.updateServerMedia($scope.parentVideo[0].id, settings);
      };

      $scope.updateServerMedia = (id, settings) => {
        if (settings?.files?.extra_data) {
          settings.files.extra_data.medication = $scope.capitalize($scope.product);
          MediaService.setMediaInfo(id, settings).then((response) => {
            $scope.participantData.files.forEach((arr, outerIndex) => {
              arr.forEach((file, innerIndex) => {
                if (file.id === id) {
                  $scope.participantData.files[outerIndex][innerIndex] = response.files;
                  $scope.videoObservations = response.files.extra_data.video_observations;
                }
              });
            });
          });
        }
      };

      $scope.copyLink = () => {
        $scope.linkCopied = true;
      };

      $scope.closeModal = () => {
        $scope.showModal = false;
        $scope.videoObservations = null;
      };

      $scope.prepTreatmentVideosForDownload = () => {
        let treatmentVids = [];
        $scope.participantData.files.forEach((videos) => {
          videos.forEach((video, index) => {
            const vid = {
              url: video.storage_url,
              treatment: video.extra_data.treatment,
              count: index + 1,
            };
            treatmentVids.push(vid);
          });
        });
        return treatmentVids;
      };

      $scope.getVideoCount = (videoUrl) => {
        let count = null;
        $scope.participantData.files.forEach((videos) => {
          videos.forEach((video, index) => {
            if (videoUrl === video.storage_url) {
              count = index + 1;
            }
          });
        });
        return count;
      };

      $scope.prepAllVideosForDownload = () => {
        const baselineVids = $scope.baselineVideos.map((video, index) => {
          return {
            url: video.storage_url,
            treatment: 0,
            count: index + 1,
          };
        });
        const allVideos = []
          .concat(...baselineVids, ...$scope.prepTreatmentVideosForDownload())
          .filter((video) => {
            return !!video.url;
          });
        return allVideos;
      };

      $scope.downloadVideos = (videoToDownload) => {
        const zip = new JSZip();
        const videos =
          videoToDownload?.map((video) => {
            return {
              url: video.storage_url,
              treatment: video.extra_data.treatment,
              count: $scope.getVideoCount(video.storage_url) || 1,
            };
          }) || $scope.prepAllVideosForDownload();
        let promises = [];

        if (videoToDownload) {
          $scope.downloadingVideo = true;
          $timeout(() => {
            $scope.downloadingVideo = false;
          }, 1000);
        }

        videos.forEach((video) => {
          const filename =
            video.treatment === 0
              ? `baseline-video-${video.count}.mp4`
              : `treatment-${video.treatment}-video-${video.count}.mp4`;
          const getFile = new Promise((resolve, reject) => {
            fetch(video.url)
              .then((file) => {
                zip.file(filename, file.blob({ type: 'video/mp4' }), { binary: true });
                resolve(true);
              })
              .catch((err) => {
                console.warn(err);
                reject(err);
              });
          });
          promises.push(getFile);
        });

        Promise.allSettled(promises).then(() => {
          if (angular.equals(zip.files, {})) {
            $rootScope.showErrorModal = true;
            return;
          }

          zip.generateAsync({ type: 'blob' }).then((content) => {
            FileSaver.saveAs(content, `${$scope.participantData.name}-videos.zip`);
          });
        });
      };

      $scope.setInitialTreatmentDate = (date) => {
        const settings = {
          files: {
            extra_data: {
              initial_treatment_date: date,
            },
          },
        };
        $scope.initialTreatmentDate.previous = $scope.initialTreatmentDate.current;
        $scope.initialTreatmentDate.current = date;
        $scope.updateServerMedia($scope.parentVideo[0].id, settings);
      };

      $scope.setObservations = () => {
        const settings = {
          files: {
            extra_data: {
              vet_observations: $scope.vetObservations,
            },
          },
        };
        $scope.updateServerMedia($scope.parentVideo[0].id, settings);
        $scope.parentVideo[0].extra_data.vet_observations = $scope.vetObservations;
      };

      $scope.saveVideoNotes = () => {
        $scope.savingVideoNotes = true;
        $scope.videoObservations = angular.element('#video-observations').val();
        const settings = {
          files: {
            extra_data: {
              video_observations: $scope.videoObservations,
            },
          },
        };
        $scope.updateServerMedia($scope.loadedMedia[0].id, settings);
        $scope.loadedMedia[0].extra_data.video_observations = $scope.videoObservations;
        $timeout(() => {
          $scope.savingVideoNotes = false;
        }, 1000);
      };

      /*
       *
       *  Main
       *
       */

      MediaService.getMediaByPet(
        $scope.petId,
        $scope.order,
        $scope.mediaCategories,
        $scope.pageSize,
      ).then((response) => {
        if (response.media.length === 0) {
          $location.path('/experience-librela');
        }
        $scope.participantData = [];

        let pet = response.media[0].pets[0];
        pet.owner = response.media[0].user;
        pet.files = [];
        response.media.forEach((file) => {
          pet.files[file.extra_data.treatment] = pet.files[file.extra_data.treatment]
            ? [...pet.files[file.extra_data.treatment], file]
            : [file];
          pet.files[file.extra_data.treatment] = utilitiesV2
            .sortArrayByDate({
              array: pet.files[file.extra_data.treatment],
              sortField: 'created',
            })
            .filter((f) => f?.extra_data?.medication === $scope.capitalize($scope.product));
        });
        $scope.baselineVideos = response.media.filter(
          (media) =>
            media?.extra_data?.treatment === 0 &&
            media?.extra_data?.medication === $scope.capitalize($scope.product),
        );
        $scope.parentVideo = response.media.filter(
          (media) =>
            media?.extra_data?.is_parent === true &&
            media?.extra_data?.medication === $scope.capitalize($scope.product),
        );
        $scope.parentVideo =
          $scope.parentVideo?.length > 0 ? $scope.parentVideo : [].concat($scope.baselineVideos[0]);
        $scope.initialTreatmentDate.current =
          $scope.parentVideo[0]?.extra_data?.initial_treatment_date;
        $scope.vetObservations = $scope.parentVideo[0]?.extra_data?.vet_observations;
        $scope.participantData = pet;

        $scope.selectedTrackingBehavior = $scope.parentVideo[0]?.extra_data?.tracking_behavior
          ? $scope.parentVideo[0].extra_data.tracking_behavior
          : 'default';
        if ($scope.selectedTrackingBehavior === 'default') {
          $timeout(() => {
            $scope.toggleTrackingBehaviorOptions();
          }, 1000);
        }
        $scope.participantData.files.shift();

        // Get pet_health_data to get weight of pet
        PetsService.getPetHealthData($scope.petId, 'categories', 'weight').then((petData) => {
          if (
            petData.categories.length > 0 &&
            petData.categories[0].hasOwnProperty('pet_health_data')
          ) {
            if (petData.categories[0].pet_health_data !== null) {
              $scope.weight = petData.categories[0].pet_health_data[0].value;
            }
          }
        });
      });

      $document[0].body.classList.add($scope.product.toLowerCase());

      /*
       *
       *  Watchers
       *
       */

      $scope.$watch('initialTreatmentDate.current', (newVal, oldVal) => {
        if ($scope.initialTreatmentDate?.previous !== $scope.initialTreatmentDate?.current) {
          const selectedDate = new Date(newVal);
          const previousDate = new Date(oldVal);
          const currentDate = new Date();

          $scope.isInitialTreatmentDateValid =
            $scope.initialTreatmentDate.current && selectedDate <= currentDate;
          $scope.currentDate = currentDate;

          if (
            $scope.initialTreatmentDate.current &&
            $filter('date')(selectedDate, 'shortDate') !==
              $filter('date')(previousDate, 'shortDate')
          ) {
            $scope.setInitialTreatmentDate(newVal);
          }
        }
      });

      $scope.$watch('downloadingAllVideos', (newVal) => {
        if (newVal === true) {
          $timeout(() => {
            $scope.downloadingAllVideos = false;
          }, 1000);
        }
      });

      $scope.$watch('savingObservations', (newVal) => {
        if (newVal === true) {
          $timeout(() => {
            $scope.savingObservations = false;
          }, 1000);
        }
      });
    },
  );
